// @TODO temp
export default ({ redirect }) => {
    return redirect('/');
};
